import type { RefinementTrigger } from '@/lib/analysis/refinement-policy'

export function buildAnalysisRescanUrl(input: {
  analysisId?: string | null
  mode: 'identify' | 'diagnose' | 'weed'
  /** When set (with resumeImageUrl), the homepage restores straight into the
   *  refinement step instead of a bare upload form. The token is what keeps
   *  the additive re-run quota-exempt for a bearer-link viewer. */
  resumeImageUrl?: string | null
  zipCode?: string | null
  sourceResultAccessToken?: string | null
  refinementTrigger?: RefinementTrigger | null
}): string {
  const params = new URLSearchParams()
  if (input.analysisId) params.set('rescanOfAnalysisId', input.analysisId)
  if (input.resumeImageUrl) {
    params.set('resume', '1')
    params.set('imageUrl', input.resumeImageUrl)
    if (input.zipCode) params.set('zipCode', input.zipCode)
    if (input.sourceResultAccessToken) {
      params.set('sourceResultAccessToken', input.sourceResultAccessToken)
    }
    if (input.refinementTrigger) params.set('refinementTrigger', input.refinementTrigger)
  }

  const pathname = input.mode === 'diagnose' ? '/diagnose' : '/'
  const query = params.toString()
  return query ? `${pathname}?${query}` : pathname
}
